import * as React from "react";

export const AxisLabel = React.createClass<AxisLabelProps, {}>({
  render() {
    let {
      value,
      padding,
      style,
      isVertical,
      textAlign,
      viewBox: { x, y, width, height },
      dy
    } = this.props;
    let axisPadding = padding ? padding : 0;

    let cx = isVertical ? x + axisPadding : x + width / 2;
    let cy = isVertical ? height / 2 + y : height / 2 + y + axisPadding;
    const rot = isVertical ? `270 ${cx} ${cy}` : 0;

    return (
      <text
        x={cx}
        y={cy}
        transform={`rotate(${rot})`}
        dy={dy}
        textAnchor={textAlign ? textAlign : "middle"}
        fill="#52525F"
        style={style}
      >
        {value}
      </text>
    );
  }
});



// WEBPACK FOOTER //
// ./client/modules/core/Chart/CartesianChart/common/AxisLabel/index.tsx